<div class="http-loading" *ngIf="loading$ | async" aria-label="Cargando"></div>

<section class="http-error-banner" *ngIf="lastError$ | async as httpError" role="alert" aria-live="polite">
  <div class="http-error-content">
    <strong>Error de conexión</strong>
    <span>{{ httpError.message }}</span>
    <small class="http-error-meta">
      Módulo: {{ httpError.modulo }} | HTTP {{ httpError.status }} | {{ httpError.method }} {{ httpError.url }}
      <ng-container *ngIf="httpError.codigo">| Código: {{ httpError.codigo }}</ng-container>
      <ng-container *ngIf="httpError.traceId">| Trace: {{ httpError.traceId }}</ng-container>
    </small>
  </div>
  <button type="button" class="http-error-close" (click)="cerrarError()">Cerrar</button>
</section>

<router-outlet />
